__turbopack_context__.v({
  "back": "_53FH2G_back",
  "close": "_53FH2G_close",
  "header": "_53FH2G_header",
  "indicator": "_53FH2G_indicator",
  "indicator-group": "_53FH2G_indicator-group",
  "logo": "_53FH2G_logo",
});
